import { render, staticRenderFns } from "./CompanionDailyContent.vue?vue&type=template&id=238458eb&scoped=true&lang=pug&"
import script from "./CompanionDailyContent.vue?vue&type=script&lang=js&"
export * from "./CompanionDailyContent.vue?vue&type=script&lang=js&"
import style0 from "./CompanionDailyContent.vue?vue&type=style&index=0&id=238458eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238458eb",
  null
  
)

export default component.exports